(function () {
    "use strict";

    angular.module("app").controller("PhysicalInstallationController", PhysicalInstallationController);

    PhysicalInstallationController.$inject = ["controllerDecorator", "physicalInstallation"];
    function PhysicalInstallationController(controllerDecorator, physicalInstallation) {

        const context = { InstallationId: null };

        const vm = this;

        activate();

        function activate() {
            controllerDecorator.Decorate(vm, []);

            const parsed = vm.ParsePrettyUrl();
            context.InstallationId = parsed.id;

            if (context.InstallationId !== null) {
                load();
            }
            else {
                vm.SetLoadingState(false);
                vm.ShowError("Cannot activate view");
            }
        }

        function load() {
            physicalInstallation.Get(
                context.InstallationId,
                r => {
                    vm.installation = r.data;

                    vm.AdministrativeZones = vm.installation.Zones.filter(z => z.Type === 0);

                    for (const az of vm.AdministrativeZones)
                        az.Children = vm.installation.Zones.filter(z => z.ParentId === az.PublicId);
                },
                vm.ShowError,
                () => vm.SetLoadingState(false)
            );

            physicalInstallation.GetRequests(
                context.InstallationId,
                r => vm.Requests = r.data,
                vm.ShowError,
            );
        }
    }
})();
